import url from 'url'
import { updateAppUrl } from 'lib/url/route'
import parse from 'lib/url/parse'
import { urlQuery, objectToQueryString } from 'lib/helpers'
import { DEFAULT_APP } from './constants'
// We need a way to pull SPECIAL Query Params for ALGOLIA
// Ex: hitsPerPage, page, sort
export const getPageParamsQuery = (href: string = ''): Record<string, any> => {
  const { query } = url.parse(href, true)
  const { hitsPerPage, page } = query || {}
  return {
    hitsPerPage,
    page,
  }
}
// Location URL
// queryParams merged attributes to create url  => ...selectedFacets, ...algoliaQuery, ...appQuery, ...params
export const generateLocationUrl = ({
  urlPathString,
  queryParams,
}: Record<string, any>): string => {
  const queryString = urlQuery(queryParams)
  return `${urlPathString}${queryString}`
}
export const updateFeatureUrl = (href: string): void => {
  // Pagination causes problems, we do NOT have a way to create APP query from component
  // We will manually decode and create APP => `"/public/feature?category=photography&keyword=cat&hitsPerPage=50&page=4`
  // Eliminate first EMPTY value => ['', 'painting', 'cat', 'feature' ]
  const { path, query } = parse(href) || {}
  const [category, keyword] = path.split('/').filter(Boolean)
  const app = `${DEFAULT_APP}?${objectToQueryString({
    category,
    keyword,
    ...query,
  })}`
  updateAppUrl({
    app,
    href,
  })
}